export default __webpack_public_path__ + "static/media/download.5bed929a.jpg";